import React from 'react';
import StatusBadge from './StatusBadge';
import OptionsMenu from './OptionsMenu';
import { formatAmount } from '../../../Common/utils';

export default function TableRow({ id, protocol, description, amount, type, createdAt, status }) {
    return (
        <tr>
            <th scope="row">{protocol}</th>
            <td>
                <span>{description}</span>
                <small className="d-block">{type}</small>
            </td>
            <td>{formatAmount(Math.abs(amount))}</td>
            <td>{new Date(createdAt).toLocaleDateString('pt-BR')}</td>
            <td>
                <StatusBadge status={status} />
            </td>
            <td className="text-right">
                <OptionsMenu protocol={protocol} status={status} />
            </td>
        </tr>
    );
}




// WEBPACK FOOTER //
// ./src/ZWallet/Operations/components/TableRow.js